import React from 'react';
import {styled, keyframes} from '@mui/material/styles';

export interface PoppaysLoaderProps {
  testID?: string;
  light?: boolean;
  absolute?: boolean;
  className?: string;
}

// Define the animations
const dashLeftAnimation = keyframes`
  90% {
    stroke-dashoffset: 230;
  }
  100% {
    stroke-dashoffset: 250;
  }
`;

const dashRightAnimation = keyframes`
  100% {
    stroke-dashoffset: 250;
  }
`;

// Styled components
const Container = styled('div')<{light?: boolean; absolute?: boolean}>(
  ({light, absolute}) => ({
    'position': absolute ? 'absolute' : 'fixed',
    'top': 0,
    'bottom': 0,
    'left': 0,
    'right': 0,
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'padding': 0,
    'background': light
      ? 'rgba(255, 255, 255, 0.5)'
      : 'rgba(255, 255, 255, 0.9)',
    'zIndex': 20,
    '& svg': {
      width: '40px',
      height: '40px',
    },
    '& svg polyline': {
      stroke: light ? 'white' : undefined,
    },
  })
);

const LoaderBracket = styled('polyline')({
  fill: 'none',
  stroke: '#d9d9d9',
  strokeMiterlimit: 10,
  strokeWidth: '6px',
  strokeDasharray: 100,
});

const LoaderBracketLeft = styled(LoaderBracket)({
  animation: `${dashLeftAnimation} 1.5s linear infinite`,
});

const LoaderBracketRight = styled(LoaderBracket)({
  animation: `${dashRightAnimation} 1.5s reverse linear infinite`,
});

/**
 * PoppaysLoader - A branded loading indicator component
 */
function PoppaysLoader({
  testID = 'poppays-loader',
  light,
  absolute,
  className = '',
}: PoppaysLoaderProps) {
  return (
    <Container
      light={light}
      absolute={absolute}
      className={className}
      data-testid={testID}
    >
      <svg viewBox="0 0 40 40">
        <LoaderBracketLeft points="11.83 2.96 2.96 2.96 2.96 36.96 11.96 36.96" />
        <LoaderBracketRight points="28.08 2.96 36.96 2.96 36.96 24.96 27.96 24.96" />
      </svg>
    </Container>
  );
}

export default PoppaysLoader;
